// Starting prices by market. Edit these numbers to change prices everywhere
// (pricing page, market pages, FAQs and the business schema).
export const PRICING = {
  IN: {
    country: "India",
    label: "India (₹ INR)",
    website: "₹25,000",
    growth: "₹10,000",
    note: "Prices exclude GST where applicable.",
  },
  US: {
    country: "United States",
    label: "USA ($ USD)",
    website: "$999",
    growth: "$299",
    note: "Billed in USD. Calls scheduled in your time zone.",
  },
  AE: {
    country: "United Arab Emirates",
    label: "UAE / Dubai (AED)",
    website: "AED 3,499",
    growth: "AED 999",
    note: "Billed in AED. Gulf Standard Time is 1.5 hours behind India, so our working day overlaps yours.",
  },
};

export const COUNTRY_CODE = { India: "IN", "United States": "US", "United Arab Emirates": "AE" };

// What each plan includes, as described on the homepage ("Build Once. Grow
// Continuously.") and the service pages. Scope and page count are agreed in
// the custom plan before work starts.
export const WEBSITE_INCLUDES = [
  "Premium custom design and build",
  "SEO foundation included",
  "Lead capture and WhatsApp built in",
  "Mobile-first and fast",
  "Page copy shaped from your notes",
  "Analytics, WhatsApp integration and a walkthrough at launch",
  "Yours from day one, no lock-in",
];

export const GROWTH_INCLUDES = [
  "Monthly SEO improvements",
  "New blog articles",
  "Location landing pages",
  "Website updates",
  "New lead-generation sections",
  "Conversion optimization",
  "Speed optimization",
  "Growth recommendations",
];
